import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { OperationResult } from '@tb/auth';
import { AuthorizationProperties } from 'src/app/authentication/auth-info';
import { CustomerService } from 'src/app/core/services/customer.service';
import { LoadingService } from 'src/app/core/services/loading.service';
import { LoginService } from 'src/app/core/services/login.service';
import { VerticalSolutionsService } from 'src/app/core/services/verticalsolutions.service';
import { ItemDescription, SalesModule, SupportedCountries } from 'src/app/model/item';
import { VerticalProduct } from 'src/app/model/ProductDto';
import { SerialNumerItem } from 'src/app/model/serialNumberItem';
import { WorkFlowService } from 'src/app/core/services/work-flow.service';
import { Validators, FormControl } from '@angular/forms';
import { CmsObject } from 'src/app/model/cmsobject';
import { CmsService } from 'src/app/core/services/cms.service';
import { NavigateService } from 'src/app/core/services/navigate.service';
import { TranslatedVariables } from 'src/app/commons/translated-variables';
@Component({
    selector: 'ms-generate-serial-numbers',
    templateUrl: './generate-serial-numbers.component.html',
    styleUrls: ['./generate-serial-numbers.component.scss'],
})
export class GenerateSerialNumbersComponent implements OnInit {
    public cmsObj: CmsObject[];
    signatureSelected: string;
    loading: boolean = false;
    authorizationStored;
    authorizationProperties: AuthorizationProperties;
    verticalSolutionList: VerticalProduct[] = [];
    signature: string;
    showEmbeddedItems: boolean = false;
    embeddedItemsList: ItemDescription[] = [];
    selectedItemCode: string;
    shortNamesList: SalesModule[] = [];
    supportedCountriesList: SupportedCountries[] = [];
    countrySelected: string = '';
    tableFilesVisible: boolean = false;
    @ViewChild('productShortModule') private productShortModule: ElementRef;
    @ViewChild('salesModuleShortModule') private salesModuleShortModule: ElementRef;
    serialNumbersIntroduction: string;
    showMessage = false;
    isError = false;
    noItems = true;
    messageBoxMessage = '';
    serialNumberList: SerialNumerItem[] = [];
    snContentFile: string ='';
    productShortNameControl: FormControl;
    salesModuleShortNameControl: FormControl;


    constructor(
        public cmsService: CmsService,
        private verticalSolutionService: VerticalSolutionsService,
        private customerService: CustomerService,
        public loadingService: LoadingService,
        private loginService: LoginService,
        private workFlow: WorkFlowService,
        public navigateService: NavigateService,
        private translatedVariable: TranslatedVariables
    ) {
      this.productShortNameControl = new FormControl('', [ Validators.maxLength(4), Validators.minLength(4),  Validators.pattern(('^[0-9A-Za-z]+$'))]);
      this.salesModuleShortNameControl = new FormControl('', [ Validators.maxLength(4), Validators.minLength(4),  Validators.pattern(('^[0-9A-Za-z]+$'))]);
    }

    async ngOnInit() {
      await this.getCmsObj();
      this.customerService.companyInfo$.subscribe(async (companyInfo) => {
          if (!companyInfo) return;
          this.loading = true;
          this.loadingService.setLoading(this.loading);
          await this.BindData();
          this.loading = false;
          this.loadingService.setLoading(this.loading);
      });
    }

    async getCmsObj() {
      //recupero le stringhe della pagina
      this.cmsObj = await this.cmsService.getCmsObj(this.workFlow.getLanguageForCms(), 'vs_generateserialnumbers');
      this.serialNumbersIntroduction = this.cmsObj.find(
          (x) => x.ContentName == 'vs_generateserialnumbers.introduction'
      ).ContentTranslation;
  }
    private async BindData() {
        this.authorizationStored = this.loginService.getauthinfo();
        this.authorizationProperties = JSON.parse(this.authorizationStored);
        let result: OperationResult = await this.verticalSolutionService.getAllProductsByReseller(
            this.verticalSolutionService.currentCodiceAzienda,
            true,
            true
        );
        if (result.Result) {
            this.verticalSolutionList = result.Content as VerticalProduct[];
            this.noItems = this.verticalSolutionList.length<=0;
        }
    }

    setDisabled() {
      return !this.signatureSelected || this.signatureSelected == 'none';
    }
    setShortNamesButtonDisabled() {
      return this.productShortModule?.nativeElement.value.length < 4 || this.salesModuleShortModule?.nativeElement.value.length < 4
      || this.productShortNameControl.invalid || this.salesModuleShortNameControl.invalid;
    }
    public async onSolutionChange(event: any) {
      this.tableFilesVisible = false;
      this.authorizationStored = this.loginService.getauthinfo();
      this.authorizationProperties = JSON.parse(this.authorizationStored);
      this.signature = event.value;
      let opResult: OperationResult = await this.verticalSolutionService.getEmbeddedItemsCode(
          this.signature,
          this.authorizationProperties.accountName
      );
      if (opResult.Result) {
          this.embeddedItemsList = opResult.Content as ItemDescription[];
          this.showEmbeddedItems = this.embeddedItemsList.length > 0;
      }
      let opResultCountries = await this.verticalSolutionService.getSupportedCountries();
      if (opResultCountries.Result) {
          this.supportedCountriesList = opResultCountries.Content as SupportedCountries[];
      }
    }
    addShortNames() {
      let salesModule: SalesModule = new SalesModule();
      salesModule.ProductID = this.productShortModule.nativeElement.value.toUpperCase();
      salesModule.SalesModuleShortName = this.salesModuleShortModule.nativeElement.value.toUpperCase();
      this.shortNamesList.push(salesModule);
      this.tableFilesVisible = this.shortNamesList.length>0;

    }

    deleteShortNames(shortName: SalesModule) {
      for (let i = 0; i < this.shortNamesList.length; i++) {
        let f = this.shortNamesList[i];
        if (shortName.SalesModuleShortName === f.SalesModuleShortName) {
          this.shortNamesList.splice(i, 1);
          break;
        }
      }
      if (this.shortNamesList.length == 0) this.shortNamesList = [];
      else this.shortNamesList = Object.assign(this.shortNamesList);
      this.tableFilesVisible = this.shortNamesList.length>0;
    }

    public async onCountryChange(event: any) {
      this.countrySelected = event.value;
    }

    writeContents(content, fileName, contentType) {
      var a = document.createElement('a');
      var file = new Blob([content], { type: contentType });
      a.href = URL.createObjectURL(file);
      a.download = fileName;
      a.click();
    }

    async generateSerialNumber() {
      this.loading = true;
      this.loadingService.setLoading(this.loading);
        let opResult: OperationResult = await this.verticalSolutionService.generateSerialNumbers(
          this.shortNamesList,
          this.signature,
          this.verticalSolutionService.currentCodiceAzienda,
          this.countrySelected
        );
        this.isError = !opResult.Result;
        if (opResult.Result) {
          this.serialNumberList = opResult.Content as SerialNumerItem[];
          this.snContentFile ='';
          for (let i = 0; i < this.serialNumberList.length; i++)
          {
            let sn = this.serialNumberList[i];
            this.snContentFile += '\n' + "ShortName: " + sn.ShortName+ '\n' + "SolutionCode: " + sn.SolutionCode+'\n' + "Serial Number:" + sn.Serials[0]+'\n';
          }
          this.writeContents(this.snContentFile, 'SerialNumbers' + '.txt', 'text/plain');
          this.workFlow.showSnackBar(this.translatedVariable.serialNumbersGeneratioOk);
          this.navigateService.goToVerticalSolution();

      }
        else
        {
          this.showMessage = true;
          this.messageBoxMessage = opResult.Message;
        }
        this.loading = false;
        this.loadingService.setLoading(this.loading);
    }


    setGenerateSNDisabled() {
        return (
            !this.signatureSelected ||
            this.signatureSelected.length == 0 ||
            this.signatureSelected == 'none' ||
            this.shortNamesList.length == 0 ||
            !this.countrySelected ||
            this.countrySelected.length == 0 ||
            this.countrySelected == 'none'
        );
    }
}
